var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 5,
    viewBox: "0 0 14 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 1C1.6 1 1 1.6 1 2.33333C1 3.06667 1.6 3.66667 2.33333 3.66667C3.06667 3.66667 3.66667 3.06667 3.66667 2.33333C3.66667 1.6 3.06667 1 2.33333 1Z",
    stroke: "#757777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1C10.9333 1 10.3333 1.6 10.3333 2.33333C10.3333 3.06667 10.9333 3.66667 11.6666 3.66667C12.4 3.66667 13 3.06667 13 2.33333C13 1.6 12.4 1 11.6666 1Z",
    stroke: "#757777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 1C6.26669 1 5.66669 1.6 5.66669 2.33333C5.66669 3.06667 6.26669 3.66667 7.00002 3.66667C7.73335 3.66667 8.33335 3.06667 8.33335 2.33333C8.33335 1.6 7.73335 1 7.00002 1Z",
    stroke: "#757777"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.b99710d249b49a4e6db561138dcd2c2d.svg";
export { ForwardRef as ReactComponent };